var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.683,
    height: 21.272,
    viewBox: "0 0 22.683 21.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sliders",
    d: "M16.3,2.419A2.126,2.126,0,1,0,18.43,4.545,2.126,2.126,0,0,0,16.3,2.419ZM12.83,3.836a3.544,3.544,0,0,1,6.947,0h2.906V5.254H19.776a3.544,3.544,0,0,1-6.947,0H0V3.836ZM6.379,9.507a2.126,2.126,0,1,0,2.126,2.126A2.126,2.126,0,0,0,6.379,9.507ZM2.906,10.925a3.544,3.544,0,0,1,6.947,0h12.83v1.418H9.853a3.544,3.544,0,0,1-6.947,0H0V10.925ZM16.3,16.6a2.126,2.126,0,1,0,2.126,2.126A2.126,2.126,0,0,0,16.3,16.6ZM12.83,18.013a3.544,3.544,0,0,1,6.947,0h2.906v1.418H19.776a3.544,3.544,0,0,1-6.947,0H0V18.013Z",
    transform: "translate(0 -0.997)",
    fill: "#bbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.b95afa0df0a8271d86c530ea3d861527.svg";
export { ForwardRef as ReactComponent };